export default "__VITE_ASSET__b4f9dab8__"